import React from 'react'
import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Form, Empty, Spin, PageHeader, Button } from 'antd'
import useSWR from 'swr'

import { serialize } from '../../network/request'
import StoryService from '../../network/services/story'
import StoryForm from './StoryForm'

const StoryDetail = () => {
  const navigate = useNavigate()
  const { id } = useParams()

  const [form] = Form.useForm()
  const [isLoading, setIsLoading] = useState(false)

  const saveAction = (
    <Button
      key={'save'}
      type="primary"
      onClick={() => {
        form.submit()
      }}
      loading={isLoading}
    >
      Save
    </Button>
  )
  const discardAction = (
    <Button
      key={'discard'}
      type="ghost"
      onClick={() => {
        navigate('/dashboard/stories')
      }}
    >
      Discard
    </Button>
  )
  const previewAction = (
    <Button
      key={'save'}
      type="primary"
      onClick={() => {
        window.open(`https://hummus-fe.vercel.app/preview/${id}`, '_blank')
        // For Debug
        // window.open(`http://localhost:3001/preview/${id}`, '_blank')
        // Ngrok Debug to bypass CORS
        // window.open(`/preview/${id}`, '_blank')
      }}
      loading={isLoading}
    >
      Preview
    </Button>
  )

  // use this to preload
  const {
    data: response,
    error,
    mutate
  } = useSWR(serialize(id !== 'new' ? StoryService.get(id) : null))

  if (error) {
    console.log(error)
    return <Empty description={error?.message ?? 'Please try again later'} />
  }

  if (!response && id !== 'new') {
    return (
      <PageHeader>
        <Spin />
      </PageHeader>
    )
  }

  const record = response?.data

  const refresh = () => {
    if (id != null) {
      if (id === 'new') {
      } else {
        mutate()
      }
    }
  }

  return (
    <PageHeader
      title={id === 'new' ? 'New Story' : 'Edit Story'}
      extra={[previewAction, discardAction, saveAction]}
      onBack={() => navigate('/dashboard/stories')}
    >
      <StoryForm
        form={form}
        initialValue={record}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        refresh={refresh}
      />
    </PageHeader>
  )
}

export default StoryDetail
